import {
    DEPARTMENT_SELECT,
    SECTION_SELECT,
    ROLE_SELECT,
    USER_LIST_SECTION,
    ACCOR_BUTTON,
    SEARCH_INPUT,
    SEARCH_BUTTON,
    HEADER_CONTENT
} from "../constants/elementConst";

import {usersTemplate} from "./users";
import {sectionTemplate} from "./section";
import {roleTemplate} from './role';
import {department} from "./department";
import headerTemplate from './header';
import store from '../store';

export default function(){
    const userData = store.get("userList");

    return `
        <header class="employee_register__header employee_register--pt-35 employee_register--bg--grey-100 employee_register--mb-45">
            <h2 class="employee_register__title employee_register--font-size-21 employee_register--mx-40 employee_register--mb-10">
                Søk etter ansatt
            </h2>
            
            <div class="employee_register__search employee_register--px-40">
                <div id="employee_register__searchform">
                    <div class="employee_register--searchgroup employee_register--mb-20">
                        <input type="text" 
                            name="search" 
                            data-js="${SEARCH_INPUT}"
                            class="employee_register__search-input employee_register--p-10" 
                            placeholder="${store.get("searchPlaceholderCaption")}" 
                            aria-label="Søk på navn, avdeling, seksjon e.l."/>
                            
                        <button type="button" 
                            data-js="${SEARCH_BUTTON}"
                            data-click="${SEARCH_BUTTON}"
                            class="employee_register__search-button employee_register--p-10">
                            <span class="budicon budicon-search employee_register__search-icon"></span>
                        </button>
                    </div>
                </div>
            </div>
            
            <div class="employee_register__filters">
                <button class="employee_register__accordion__button employee_register--bg--grey-400 employee_register--mx-40 employee_register--px-20 employee_register--py-10 employee_register__btn-link"
                    data-toggle="employee_register__accordion--filter" 
                    data-js="${ACCOR_BUTTON}"
                    data-click="${ACCOR_BUTTON}"
                    aria-expanded="false"
                >
                    <header class="">
                        Flere valg
                        <span class="budicon budicon-chevron-bottom employee_register__icon--adjust-5 employee_register--pl-5 employee_register__text--bold" aria-hidden="true"></span>
                    </header>
                </button>
                
                <div id="employee_register__accordion--filter" 
                    class="employee_register__accordion--collapse employee_register--px-40 employee_register--py-30 employee_register--bg--grey-400  ${store.get("isFilterVisible") ? "employee_register__accordion--open":""}" 
                    data-js="employee_register__accordion--filter"
                >
                    <div class="employee_register__row">
                        <div class="employee_register--mb-20 employee_register__col-md-6">
                            <label class="employee_register__text--bold employee_register--d-block" 
                                for="employee_register--select_department">
                                ${store.get("selectDepartmentCaption")}
                            </label>
                            
                            <select id="employee_register--select_department" 
                                class="employee_register--w-100 employee_register--p-10 employee_register__filters__select"
                                data-js="${DEPARTMENT_SELECT}">
                                
                                ${department()}
                            </select>
                        </div>
                        
                        <div class="employee_register--mb-20 employee_register__col-md-6">
                            <label class="employee_register__text--bold employee_register--d-block employee_register--font-size-16" 
                                for="employee_register--select_section">
                                ${store.get("selectSectionCaption")}
                            </label>
                            
                            <select id="employee_register--select_section" 
                                class="employee_register--w-100 employee_register--p-10 employee_register__filters__select" 
                                data-js="${SECTION_SELECT}">
                                
                                ${sectionTemplate()}
                            </select>
                        </div>
                        <!--
                        <div class="employee_register--mb-20">
                            <label class="employee_register__text--bold employee_register--d-block employee_register--font-size-16" 
                                for="employee_register--select_role">
                                Velg rolle
                            </label>
                            
                            <div class="employee_register__custom-select">
                                <select id="employee_register--select_role" 
                                    class="employee_register--w-100 employee_register--p-10 employee_register__filters__select"
                                    data-js="${ROLE_SELECT}">
                                    ${roleTemplate(userData)}
                                </select>
                            </div>
                        </div>
                        -->
                    </div>
                </div>
            </div>
        </header>
        
        <main>
            <div data-js="${HEADER_CONTENT}">
                ${headerTemplate()}
            </div>
            
            <section class="employee_register__user-list" data-js="${USER_LIST_SECTION}">
                ${usersTemplate()}
            </section>
        </main>
    `;
}